<div [formGroup]="form">
  <mtn-email-address-field [form]="form" [isRequired]="true"></mtn-email-address-field>

  <div fxLayout="row" fxLayoutGap="15px">
    <mtn-text-field class="default-field-width"
                    [form]="form"
                    controlName="firstName"
                    [placeholder]="'CREATE_USER_FORM.FIRST_NAME' | translate"
                    [isRequired]="true">
    </mtn-text-field>

    <mtn-text-field class="default-field-width"
                    [form]="form"
                    controlName="lastName"
                    [placeholder]="'CREATE_USER_FORM.LAST_NAME' | translate"
                    [isRequired]="true">
    </mtn-text-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <mtn-text-field class="default-field-width"
                    [form]="form"
                    controlName="title"
                    [placeholder]="'CREATE_USER_FORM.TITLE' | translate">
    </mtn-text-field>

    <mtn-phone-number-field class="default-field-width" [form]="form"></mtn-phone-number-field>
  </div>
</div>
